import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsx(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: /* @__PURE__ */ jsx(Path, { d: "M6 9h6V5l7 7-7 7v-4H6V9z", stroke: `${color}` })
    }
  );
};
Icon.displayName = "ArrowBigRight";
const ArrowBigRight = memo(themed(Icon));
export {
  ArrowBigRight
};
//# sourceMappingURL=arrow-big-right.js.map
